import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cash-stack",
  "use": "icon-cash-stack-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-cash-stack\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cash-stack\">\r\n  <path d=\"M14 3H1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1h-1z\" />\r\n  <path fill-rule=\"evenodd\" d=\"M15 5H1v8h14V5zM1 4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H1z\" />\r\n  <path d=\"M13 5a2 2 0 0 0 2 2V5h-2zM3 5a2 2 0 0 1-2 2V5h2zm10 8a2 2 0 0 1 2-2v2h-2zM3 13a2 2 0 0 0-2-2v2h2zm7-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cash-stack.svg
// module id = FiZM
// module chunks = 60